module.exports = __webpack_public_path__ + "static/media/skeleton.0063594c.svg";